@if (vm.contentType === 'ARGOS_JEWELLERY_CARE') {
  <h2 class="heading-4">How to claim</h2>

  <p class="body mt-8">
    Jewellery and watch claims need to be made in store. Please visit your nearest Argos store with:
  </p>

  <ul class="mt-8">
    <li class="body">Your item (unless it's been stolen)</li>
    <li class="body">Receipts for both your policy and the item</li>
    <li class="body">If it's been stolen, your crime reference number</li>
  </ul>
} @else if (vm.contentType === 'ARGOS_FURNITURE_CARE' || vm.contentType === 'JOHN_LEWIS_FURNITURE_CARE') {
  <h2 class="heading-4">How to claim</h2>

  <p class="body mt-8">Furniture claims can't be made in My Account.</p>
  <p class="body mt-0 sm-mt-8">
    To book a repair, please give us a call or visit
    <a class="link-text" [href]="'https://' + vm.furnitureCareWebsiteHref" target="_blank">{{
      vm.furnitureCareWebsiteLabel
    }}</a>
  </p>
} @else if (vm.contentType === 'HOME_EMERGENCY_AND_PD') {
  <h2 class="heading-4">Your {{ vm.claimType }}</h2>

  <p class="body mt-16">To make a claim or get help, you can call us 24/7.</p>

  <app-telephone-link
    class="mt-12"
    [largeFont]="true"
    postCodeMessagingClasses="max-w-480"
    [postCode]="vm.postCode"
    [phoneNumber]="vm.phone"
  />
} @else {
  <app-no-allocation-rules [claimType]="claimType()" />
}
